import type { TFeedbackStore } from '../types';

const feedbackStoreState: TFeedbackStore = {
  questions: [],
  results: {},
  questionActive: null,
  firstQuestionActive: null,
  period: {
    questionsLoading: false,
    submitLoading: false,
  },
  feedbackForm: {},
  totalStep: 0,
  feedbackFormActive: null,
  initStore: null,
};

export default feedbackStoreState;
